import { render, staticRenderFns } from "./VisualizarEventoCalendarioDialog.vue?vue&type=template&id=556e6a22"
import script from "./VisualizarEventoCalendarioDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarEventoCalendarioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports